import React from "react";
import { Science } from "@mui/icons-material";
import { meetingTypes, testWorkflows } from "../../../../data/workspaceData";
import { SectionHeader } from "../../common/WorkspaceChrome";

export function MeetingsView() {
  return (
    <>
      <section className="split-layout">
        <div className="panel">
        <SectionHeader
          eyebrow="Meetings"
          title="Scheduling for internal, client, sales, hiring, and training flows"
          text="Meeting types can create calendar events, booking forms, notes, tasks, tickets, docs, reminders, and outcome reports."
        />
        <div className="meeting-grid">
          {meetingTypes.map((meeting) => (
            <span key={meeting}>{meeting}</span>
          ))}
        </div>
        </div>
        <div className="panel">
        <SectionHeader
          eyebrow="Testing"
          title="QA workflows connected to meetings and releases"
          text="Tests connect to work items and make quality visible in project and client reports."
        />
        <div className="test-flow-grid">
          {testWorkflows.map((workflow) => (
            <article key={workflow.title}>
              <Science fontSize="small" />
              <h3>{workflow.title}</h3>
              <div className="stage-row">
                {workflow.stages.map((stage) => (
                  <span key={stage}>{stage}</span>
                ))}
              </div>
            </article>
          ))}
        </div>
        </div>
      </section>
    </>
  );
}
